// extracted by mini-css-extract-plugin
module.exports = {"component":"calendar-charter-icon_component__ZaD_Q"};